import { render, staticRenderFns } from "./capacitacion.vue?vue&type=template&id=6cbeabef&"
import script from "./capacitacion.vue?vue&type=script&lang=js&"
export * from "./capacitacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports